import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchRewardDashboard = createAsyncThunk(
    'leaderboard/fetchRewardDashboard',
    async ({ userId, organizationId }, { rejectWithValue }) => {
        const jwtToken = localStorage.getItem("jwt_token");
        const URL = `${process.env.REACT_APP_API_URL}/employee_details?user_id=${userId}&organisation_id=${organizationId}`;

        try {
            const response = await axios.get(URL, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const rewardDashboardSlice = createSlice({
    name: 'rewardDashboard',
    initialState: {
        userDetails: {},
        badgeDetails: {},
        loading: false,
        error: null,
    },
    reducers: {
        clearLeaderboard: (state) => {
            state.data = [];
            state.error = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRewardDashboard.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRewardDashboard.fulfilled, (state, action) => {
                state.loading = false;
                state.userDetails = action.payload.userDetails;
                state.badgeDetails = action.payload.badgeDetails;
            })
            .addCase(fetchRewardDashboard.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearLeaderboard } = rewardDashboardSlice.actions;
export default rewardDashboardSlice.reducer;
